import request from "@/request/request.js"; 

// 公共
const common = {
  login(data) {
    return request({
      url: "/api/admin/login",
      method: "post",
      data,
    });
  },
  wxtk(id) {
    return request({
      url: "/api/after-sales/confirm-refund/"+id,
      method: "post",
    });
  },
  senhtk(data) {
    return request({
      url: "/api/after-sales/audit",
      method: "post",
      params:data,
    });
  },
  getAdminUserInfoByToken(data) {
    return request({
      url: "/admin/auth/info",
      method: "get",
      params: data,
    });
  },
  getList(data) {
    return request({
      url: "/auth/list",
      method: "get",
      params: data,
    });
  },
};
const order = {
     gettixian(data) {
    return request({
      url: "/api/admin/withdrawal/list",
      method: "get",
      params: data,
    });
  },
  getList(data) {
    return request({
      url: "/order/list",
      method: "get",
      params: data,
    });
  },
  // 发货
  deliver(id) {
    return request({
      url: "/order/deliver/" + id,
      method: "put",
    });
  },
  // 处理退款 
  processRefund(id) {
    return request({
      url: "/order/refund/" + id,
      method: "put",
    });
  },




};
// 员工
const worker = {
  congzi(data){
    return request({
      url:"/api/admin/balance/recharge/mock",
      method:"POST",
      data
    })
  },
  getList(data) {
    return request({
      url: "/worker/list",
      params:data 
    })
  },
  getuserList(data) {
    return request({
      url: "/user/info/list",
      params:data 
    })
  },
  create(data) {
    return request({
      url: "/worker",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/worker",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/worker/" + id,
      method: "delete",
    })
  } 
};


// 员工
const feedback = {
  getList(data) {
    return request({
      url: "/api/feedback/list",
    })
  },
  delete(id) {
    return request({
      url: "/worker/" + id,
      method: "delete",
    })
  } 
};


//         <el-table-column prop="typeName" label="服务分类" />

const good = {
  getList(data) {
    return request({
      url: "/product/list",
      method: "get",
      params: data,
    })
  },
  create(data) {
    return request({
      url: "/product",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/product",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/product/" + id,
      method: "delete",
    })
  },
  //商品规格操作

  getskuList(id) {
    return request({
      url: "/product/sku/product/" + id,
      method: "get",
    })
  },
  createSku(data) {
    return request({
      url: "/product/sku",
      method: "post",
      data,
    })
  },
  updateSku(data) {
    return request({
      url: "/product/sku",
      method: "put",
      data,
    })
  },
  deleteSku(id) {
    return request({
      url: "/product/sku/" + id,
      method: "delete",
    })
  }


};
const goodType = {
  getList(data) {
    return request({
      url: "/product/category/tree",
      params:data
    })
  },
  create(data) {
    return request({
      url: "/product/category",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/product/category",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/product/category/" + id,
      method: "delete",
    })
  }
}

const serverType = {
  getList(data) {
    return request({
      url: "/service/type/tree",
      method: "get",
      params:data
    })
  },
  create(data) {
    return request({
      url: "/service/type",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/service/type",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/service/type/" + id,
      method: "delete",
    })
  }
}
const server = {
  getList(data) {
    return request({
      url: "/service/item/list",
      method: "get",
      params: data,
    })
  },
  create(data) {
    return request({
      url: "/service/item",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/service/item",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/service/item/" + id,
      method: "delete",
    })
  },
}

const noice = {
  getList(data) {
    return request({
      url: "/notice/list",
      method: "get",
      params: data,
    })
  },
  create(data) {
    return request({
      url: "/notice",
      method: "post",
      data,
    })
  },
  update(data) {
    return request({
      url: "/notice",
      method: "put",
      data,
    })
  },
  delete(id) {
    return request({
      url: "/notice/" + id,
      method: "delete",
    })
  } 
}
const shoporder={
  getList(data) {
    return request({
      url: "/order/list",
      method: "get",
      params: data,
    })
  },
  deliver(id) {
    return request({
      url: "/order/deliver/" + id,
      method: "put",
    })
  },
  process(id,data) {
    return request({
      url: "/order/refund/process/" + id,
      method: "put",
      params:data,
    })
  }
}
export default {
  common,
  order,
  worker,
  good,
  goodType,
  serverType,
  server,
  feedback,
  noice,
  shoporder
};
